import MixPanelService from '../system/services/MixPanelService';
import { getUniversityId } from '../helpers/Helpers';

import store from '../redux/store';

export const handleABTest = ({ testName }) => {
    const { ABTesting } = store.getState().widget;

    return {
        testBucket: ABTesting[testName] ? ABTesting[testName].bucket : 0,
    };
};

export const handleABTestVersion = ({ testName }) => {
    const { ABTesting } = store.getState().widget;

    return {
        testBucket: ABTesting[testName] ? (ABTesting[testName].bucket ? 'B' : 'A') : 'A',
    };
};

export const trackABTest = ({ testName, testDescription, additionalConfig = {} }) => {
    const { ABTesting } = store.getState().widget;

    MixPanelService.track(testDescription, {
        university_id: getUniversityId(),
        testBucket: ABTesting[testName] ? (ABTesting[testName].bucket ? 'B' : 'A') : 'A',
        testName,
        ...additionalConfig,
    });
};
